import { AfterViewInit, Component, Input, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";

import { SearchResultsFilterModalComponent } from "../search-results-filter-modal/search-results-filter-modal.component";
import { Subscription } from "rxjs-compat/Subscription";
import { AzureSuggestsResult } from "@rubbl-azure-search";
import { ModalService, LogService, ShareService, MarketTrackingEvents, Location } from "@rubbl-core";
import { SearchRequest, SearchResultsService } from "@rubbl-search-results";
import { fadeInOut } from "@rubbl-shared";

@Component({
  selector: "app-v2-topbar-search-results-search",
  templateUrl: "./v2-topbar-search-results-search.component.html",
  styleUrls: ["./v2-topbar-search-results-search.component.scss"],
  animations: [fadeInOut("250ms", "250ms")],
})
export class V2TopbarSearchResultsSearchComponent implements AfterViewInit, OnDestroy {
  @Input() primaryType: string;
  searchRequest: SearchRequest;
  showOverlay = false;

  facetSelectedCount: number = 0;
  searchFacetsSubscription: Subscription;

  searchTerm: string;
  cityState: string;
  location: string;

  constructor(
    private router: Router,
    private searchResultsService: SearchResultsService,
    private modalService: ModalService,
    private logService: LogService,
    private shareService: ShareService,
  ) {}

  ngAfterViewInit() {
    this.searchFacetsSubscription = this.searchResultsService.searchRequest$.subscribe(searchRequest => {
      this.searchRequest = searchRequest;
      this.searchTerm = this.searchResultsService.searchRequest.searchTerm;
      this.cityState = searchRequest.location.toCityState();
      this.facetSelectedCount = searchRequest.facetSelectedCount;
      this.location = this.searchRequest.location?.toCityStateSeo() || "";
    });
    this.searchTerm = this.searchResultsService.searchRequest.searchTerm;
  }

  ngOnDestroy() {
    this.searchFacetsSubscription?.unsubscribe();
  }

  suggestionSelected($event: AzureSuggestsResult) {
    this.searchRequest.searchTerm = $event.value;
    this.searchRequest.selectedSuggestion = $event;
  }

  locationSelected(event: Location) {
    this.searchRequest.location.location = event;
    // store this so we can look up gps coordinates
    this.searchResultsService.storeLocation(event);
  }

  useMyLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          this.searchRequest.location.location = new Location();
          this.searchRequest.location.location.address.address1 = "Current Location";
          this.searchRequest.location.location.latitude = position.coords.latitude;
          this.searchRequest.location.location.longitude = position.coords.longitude;

          this.search();
        },
        error => {
          this.searchRequest.location.location = null;
          this.search();
          if (error.code === error.PERMISSION_DENIED) {
            // alert("You denied location access. Please enable location access to use this feature.");
          }
        },
      );
      return;
    }
  }

  search() {
    let queryParams = this.searchRequest.queryParams;
    queryParams["q"] = this.searchRequest.searchTerm;
    this.router.navigate([this.searchRequest.searchResultsUrl()], {
      queryParams,
    });

    this.logService.trackEvent(
      MarketTrackingEvents.Search.Header,
      {
        event: "rentalSearch",
        searchTerm: this.searchRequest.searchTerm,
        location: this.searchRequest.location.toCityState(),
      },
      true,
    );
  }

  toggleSearchOverlay() {
    this.showOverlay = !this.showOverlay;
  }

  openFilterModal() {
    const modalRef = this.modalService.fullPageModal(SearchResultsFilterModalComponent);
    modalRef.componentInstance.searchRequest = this.searchRequest;
    modalRef.result.then(
      success => {},
      (oldFacets: any) => {},
    );
  }

  shareResults() {
    this.shareService.share("Rubbl Search Results", "Take a look at these machines on Rubbl.", window.location.href, { target: "searchResults" });
  }
}
